import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { cols, icons } from "../services/design.sevice";


//#region 

export function MoModal({ m_t,buttonText, message ,err_message ,suc_message,onClose, onOk, onCancel }) {
    return (
        <MoContainer  onClick={function (e) { onClose() }} grid place="center" pos="fixed" z="9999" w="100vw" h="100vh" bg="transparent"  >
            <MoContainer m_t={m_t} eff_shdw={{op:.25}} sdw={{x:0 ,y:0 ,sprd:'8rem' ,op:"rgba(0,0,0,0.8)"}} flex_c onClick={function (e) { e.stopPropagation(); }} w='21rem' h="13rem" b_r={{ all: "1rem" }} bg={cols.mainLight_1} >
                {/* text */}
                <MoContainer flex_c align="center" gap="0" justify="space-evenly" h="7rem" >
                    <MoSpan f_w="bold" f_size="1.02rem" w="80%"> {message} </MoSpan>
                    <MoSpan f_size="1rem" col={cols.red} w="80%"> {err_message} </MoSpan>
                    <MoSpan f_size="1rem" col={cols.green} w="80%"> {suc_message} </MoSpan>
                </MoContainer>

                {/* actions */}
                <MoContainer pd={{tb:".2rem"}} flex h="6rem" justify="center">
                  {onCancel && <Button type={ButtonTypes.disabled} onClick={onCancel} w="10rem"  title="Cancel" />}
                  <Button type={ButtonTypes.success}  onClick={onOk} w="10rem" title={`${buttonText?.ok || "Send"}`} />
                </MoContainer>
            </MoContainer>
        </MoContainer>

    )
}


export function MoTextArea({ text, onChange, value, w, h, wh, bg, col, f_size, pholder, border, b_r }) {
    return (
        <MoContainer w={w || '25rem'} h={h || "10rem"} wh={wh} bg={bg || cols.mainLight_1} border={border} b_r={b_r || { all: "1rem" }} >
            <StyleMoTextArea onChange={onChange} value={value} f_size={f_size || "1rem"} placeholder={pholder || "Enter Text ..."} col={col || cols.main_blue} >
                {text}
            </StyleMoTextArea>
        </MoContainer>
    )
}
const StyleMoTextArea = styled.textarea`
    color: ${({ col }) => col};
    font-size: ${({ f_size }) => f_size};

    font-weight : 600;
    padding : .8rem;

    resize:none ; 
    width:100%;
    height:100%;
    background :transparent;
    border:none;
    outline:none;
`;


export function Statement({ text, w, h, wh, bg, col, f_size }) {
    return (
        <MoContainer m_r="auto" pd={{ all: "2rem" }} b_r={{ all: "1rem" }} bg={bg || cols.mainLight_1} m_l="auto" grid place="center" w={w} h={h} xh={wh} >
            <MoSpan f_size={f_size || "1.5rem"} > {text} </MoSpan>
        </MoContainer>
    )
}


export function BlockScroller({ prev, next, onClick, b_offset }) {
    return (
        <MoContainer onClick={onClick} pd={{ tb: "0", lr: "1rem" }} cursor="pointer" bg={cols.greenSwamp} pos="absolute" pos_dir={next ? { b: `${2 + b_offset || 2}rem`, r: "3rem" } : { b: `${2 + b_offset || 2}rem`, l: "3rem" }} w="6rem" h="2.5rem" b_r={{ all: "1rem" }} grid place="center" >
            {next && <MoContainer flex>
                <img width="18px" src={icons.ic_fast_forward} alt="" />
                <MoSpan fs_sml col={cols.mainLight_1}> Next </MoSpan>
            </MoContainer>}
            {prev && <MoContainer flex>
                <img width="18px" src={icons.ic_fast_forward} alt="" style={{ transform: "rotateZ(180deg)" }} />
                <MoSpan fs_sml col={cols.mainLight_1}> Previous </MoSpan>
            </MoContainer>}
        </MoContainer>
    )

}
export function Title({ text }) {
    return (
        <MoSpan f_size='1.5rem' bg={cols.mainLight_3} col={cols.mainDark_black} f_w="600" >{text ? text : "📋 Title here"}</MoSpan>
    )
}
export function Flag({ isActive, b_r ,bg_all, text, onClick, bg, col, border, op, h, w ,extra}) {
    return (
        <MoContainer bg_all={bg_all} border={border} grid place="center" op={op} bg={isActive ? cols.main_purple : (bg || cols.gray)} onClick={onClick} eff_scale={{val:1.025}} eff_shdw={{ op: .25, sprd: ".5rem" }} cursor="pointer" w={w} h={h || "100%"} b_r={b_r || { all: "5rem" }} pd={{ tb: ".5rem", lr: "1rem" }} style = {extra}> <MoSpan fs_sml f_w='600' col={col || "white"}>{text}</MoSpan> </MoContainer>
    )
}

//#endregion

export const Container100 = styled.div`
    outline :1px solid ;
    width: 100vw;
    height: 100vh;
 
    overflow: hidden;

`;
export const MoContainer = styled.div`

    background: ${({ bg_all }) => bg_all  };
    
    ${({ eff_scale }) => eff_scale && css`
        :hover{
            transform: ${`scale(${eff_scale.val || 1.1})`};
        }
    ` };
    ${({ demo }) => demo && css`
    outline :1px solid ;
    ` };
    ${({ demob }) => demob && css`
    border :1px solid ;
    ` };

    ${({ border }) => border && css`
        border: ${border.w} solid ${border.col};
    ` };

    
    ${({ tra }) => tra && css`
        transition: ${tra};
    ` };

    ${({ flex_c }) => flex_c && css`
        display:flex;
        flex-direction : column;
    ` };
    ${({ flex_r }) => flex_r && css`
        display:flex;
        flex-direction : row;
    ` };
    
    overflow-y: ${({ flow_y }) => flow_y};
    overflow-x: ${({ flow_x }) => flow_x};
    overflow: ${({ flow }) => flow};

    background-color: ${({ bg }) => bg || "transparent"};

    ${({ hvr }) => hvr && css`
        :hover{
            ${hvr}
        }
    ` };
    ${({ line }) => line && css`
            ${line}
    ` };

    ${({ bg_i }) => bg_i && css`
        
        background: ${`url(${bg_i})`};
        background-position: top;
        background-repeat: no-repeat;
        background-size:cover;
    ` };
    background-size: ${({ bg_i_s }) => bg_i_s};
    transform: ${({ trfm }) => trfm};
    opacity: ${({ op }) => op};
    ${({ eff_shdw }) => eff_shdw && css`
    transition: box-shadow ${eff_shdw.dur || '.3'}s  ;
    :hover{
           box-shadow:  ${eff_shdw.x || 0} ${eff_shdw.y || 0} ${eff_shdw.sprd || "1rem"} ${eff_shdw.col || `rgba(0,0,0,${eff_shdw.op})` || "rgba(0,0,0,0.25)"};
        }
    ` };

    ${({ eff_size }) => eff_size && css`
        transition: transform ${eff_size.dur || '.2'}s  ;
        :hover{
            transform: ${`scale(${eff_size.val})` || "scale(1.4)"}
        }
    ` };
    
    margin-top: ${({ m_t }) => m_t || 0};
    margin-right: ${({ m_r }) => m_r || 0};
    margin-bottom: ${({ m_b }) => m_b || 0};
    margin-left: ${({ m_l }) => m_l || 0};
    ${({ m }) => m && css`
        margin:${m.t || 0} ${m.r || 0} ${m.b || 0} ${m.l || 0}; 
    ` };


    padding-left: ${({ pd }) => pd?.l || '0'};
    padding-right: ${({ pd }) => pd?.r || '0'};
    padding-top: ${({ pd }) => pd?.t || '0'};
    padding-bottom: ${({ pd }) => pd?.b || '0'};

    ${({ pd }) => pd && css`
        padding: ${pd.tb} ${pd.lr};
    ` };
    ${({ pd }) => pd && css`
        padding: ${pd.all};
    ` };

    ${({ flow_txt_etc }) => flow_txt_etc && css`
    text-overflow: ellipsis;
    ` };
    text-overflow: ${({ flow_txt }) => flow_txt};

    cursor: ${({ cursor }) => cursor};
    
    ${({ wh }) => wh && css`
        width:${wh};
        height:${wh};
    ` };

    width: ${({ w }) => w};
    height: ${({ h }) => h};
    max-width: ${({ max_w }) => max_w};
    min-width: ${({ min_w }) => min_w};
    max-height: ${({ max_h }) => max_h};
    min-height: ${({ min_h }) => min_h};
    ${({ flex }) => flex && css`
    display: flex;
    ` };
    ${({ wrap }) => wrap && css`
    flex-wrap: wrap;
    ` };
    
    ${({ flex_dir_c }) => flex_dir_c && css`
    flex-direction: column;
    ` };
    position: ${({ pos }) => pos};
    ${({ pos_dir }) => pos_dir && css`
    
        left: ${pos_dir.all};
        right: ${pos_dir.all};
        top: ${pos_dir.all};
        bottom: ${pos_dir.all};
    
        left: ${pos_dir.l};
        right: ${pos_dir.r};
        top: ${pos_dir.t};
        bottom: ${pos_dir.b};
    ` };
    z-index: ${({ z }) => z};
    ${({ flex_dir_r }) => flex_dir_r && css`
    flex-direction: row;
    ` };
    align-items: ${({ align }) => align};
    place-items: ${({ place }) => place};
    justify-content: ${({ justify }) => justify};

    gap: ${({ gap }) => gap || "10px"};
    ${({ grid }) => grid && css`
    display: grid;
    ` };
    grid-template-columns: ${({ tem_c }) => tem_c};
    grid-template-rows: ${({ tem_r }) => tem_r};

    ${({ b_r }) => b_r && css`
        border-top-left-radius: ${b_r.tl};
        border-top-right-radius: ${b_r.tr};
        border-bottom-left-radius: ${b_r.bl};
        border-bottom-right-radius: ${b_r.br};
        border-radius: ${b_r.all};
    ` };
${({ scroller }) => scroller && css`
    
    /* width */
    ::-webkit-scrollbar {
        width: 10px ;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: ${scroller.col || cols.gray};
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${cols.main_purple};
        border-radius: 50px;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: ${cols.main_blue};
    }
` };
${({ sdw }) => sdw && css`
    box-shadow: ${sdw.x} ${sdw.y} ${sdw.sprd} ${sdw.op} ;
` };
`;
export const MoLink = styled(Link)`
    ${({ demo }) => demo && css`
    outline :1px solid ;
    ` };
    ${({ hvr }) => hvr && css`
        :hover{
            ${hvr}
        }
    ` };
    text-decoration: none;
    font-family: Arial, Helvetica, sans-serif;
    font-size: ${({ f_size }) => f_size || "small"};
    color: ${({ col }) => col || cols.main_blue};
    background-color: ${({ bg }) => bg};
    font-weight: ${({ f_w }) => f_w || "bold"};

    margin-top: ${({ m_t }) => m_t || 0};
    margin-right: ${({ m_r }) => m_r || 0};
    margin-bottom: ${({ m_b }) => m_b || 0};
    margin-left: ${({ m_l }) => m_l || 0};

    ${({ pd }) => pd && css`
        padding: ${pd.t} ${pd.r} ${pd.b} ${pd.l};
    ` };
    ${({ pd }) => pd && css`
        padding: ${pd.tb} ${pd.lr};
    ` };

    ${({ b_r }) => b_r && css`
        border-radius: ${b_r.all};
        border-top-left-radius: ${b_r.tl};
        border-top-right-radius: ${b_r.tr};
        border-bottom-left-radius: ${b_r.bl};
        border-bottom-left-radius: ${b_r.br};
    ` };
    
    ${({ eff_hover }) => eff_hover && css`
    transition: background-color .35s, color .35s;
    :hover{
            outline:${({ bg }) => `1px solid ${bg}`} ;
            background-color: ${({ col }) => col};
            color: ${({ bg }) => bg};
        }
        ` };
    ${({ eff_hover_col }) => eff_hover_col && css`
    transition: color .35s;
    :hover{
            color: ${eff_hover_col};
        }
        ` };

    
`;
export const Alert = styled.p`
    ${({ demo }) => demo && css`
    outline :1px solid ;
    ` };
    
    padding:.5rem 1rem;
    color: white;
    border-radius: 5px;
    width: ${({ w }) => w};
    height: ${({ h }) => h};
    ${({ danger }) => danger && css`background-color: ${cols.red};`}
    ${({ success }) => success && css`background-color: ${cols.green};`}
    ${({ info }) => info && css`background-color: ${cols.main_purple};`}

    ${({ disabled }) => disabled && css`background-color: ${cols.gray};`}
    text-align:center;
`;
export const MoSpan = styled.span`
    ${({ demo }) => demo && css`
    outline :1px solid ;
    ` };
    
        ${({ etc }) => etc && css`
    text-overflow: ellipsis;
    ` };
    ${({ pointer }) => pointer && css`
        cursor:pointer;
    `};
    margin: none;
    padding: none;
    color: ${({ col }) => col || cols.main_blue} ;
    font-size: ${({ f_size }) => f_size || "3rem"} ;
    ${({ fs_sml }) => fs_sml && css`
        font-size: 1rem;
    ` };
    ${({ fs_mid }) => fs_mid && css`
        font-size: 2rem;
    ` };
    padding-left: ${({ pd }) => pd?.l || '0'};
    padding-right: ${({ pd }) => pd?.r || '0'};
    padding-top: ${({ pd }) => pd?.t || '0'};
    padding-bottom: ${({ pd }) => pd?.b || '0'};
    padding: ${({ pd }) => pd?.tb};
    ${({ pd }) => pd && css`
        padding: ${pd.tb} ${pd.lr};
    ` };
    margin : ${({ m_all }) => m_all};
    margin-top: ${({ m_t }) => m_t};
    margin-right: ${({ m_r }) => m_r};
    margin-bottom: ${({ m_b }) => m_b};
    margin-left: ${({ m_l }) => m_l};
    
    font-weight: ${({ f_w }) => f_w};
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

    width: ${({ w }) => w};
    height: ${({ h }) => h};
    max-width: ${({ max_w }) => max_w};
    min-width: ${({ min_w }) => min_w};
    max-height: ${({ max_h }) => max_h};
    min-height: ${({ min_h }) => min_h};

    ${({ b_r }) => b_r && css`
        border-radius: ${b_r.all};
        border-top-left-radius: ${b_r.tl};
        border-top-right-radius: ${b_r.tr};
        border-bottom-left-radius: ${b_r.bl};
        border-bottom-left-radius: ${b_r.br};
    ` };
    background-color: ${({ bg }) => bg};
    cursor: ${({ cursor }) => cursor};
    ${({eff_hvr})=>eff_hvr && css`
        :hover{
            ${eff_hvr}
        }
    `}
`;

//#region components

export function PopupMenu({ children, fn_close }) {
    return (
        <MoContainer onClick={fn_close} grid place="center" z="10" bg="rgba(0,0,0,0.7)" pos_dir={{ t: 0, r: 0, l: 0, b: 0 }} pos="fixed">
            <MoContainer onClick={(e) => e.stopPropagation()} b_r={{ all: "1rem" }} eff_shdw={{ op: .5, col: "white" }} bg={cols.mainLight_1} min_w="60rem" max_w="65rem" h="30rem">
                {children}
            </MoContainer>
        </MoContainer>
    )
}


//#region Input

export function Input({onFocus,onBlur, min, w, max, border, multiple, type, value, required, pholder, name, icon, onChange }) {
    return (<InputStyle w={w} border={border}>
        {icon && <img src={icon} alt="" />}
        <input onBlur={onBlur} onFocus={onFocus} min={min} max={max} multiple={multiple} style={{ width: "100%" }} type={type} required={required} name={name} onChange={onChange} value={value} placeholder={pholder} />
    </InputStyle>
    )
}
const InputStyle = styled.div`
display: flex;
align-items: center;
height: 1.4rem;
width: ${({ w }) => w};
border-bottom: 1.5px solid ${cols.main_purple};
border: ${({ border }) => border};
min-width: 10rem;
gap:15px;
padding-bottom: 5px;
input{
    border:none;
    outline:none;
    background: transparent;
    color: ${cols.mainDark_3};
    font-weight: bold;
    ::placeholder{
        color: ${cols.main_purple};
    }
}
>img{
    width:1.4rem;
    height:1.4rem;
}
`;
//#endregion

//#region Button
export function Button({ b_r, w , h, m_t, m_b, m_l, m_r, pd, title, type, disabled, onClick, children }) {

    return (
        <ButtonContainer b_r={b_r} m_t={m_t} m_b={m_b} m_l={m_l} m_r={m_r} pd={pd} type={type}>
            <button style={{ width: w, height: h }} onClick={onClick} disabled={disabled}>{title}</button>
            {children}
        </ButtonContainer>
    )
}

export const ButtonTypes = { filled: "filled", success: "success", outline: 'outline', shadowed: "shadowed", disabled: "disabled", danger: "danger", dangerOutline: "danger outline" }

const ButtonContainer = styled.div`
display: flex;
width: ${({w})=> w};
place-content:center;
margin-top: ${({ m_t }) => m_t || 0};
    margin-right: ${({ m_r }) => m_r || 0};
    margin-bottom: ${({ m_b }) => m_b || 0};
    margin-left: ${({ m_l }) => m_l || 0};
>button{
    padding: ${({ pd }) => pd?.ub || '1rem'} ${({ pd }) => pd?.lr || '2.5rem'};
    font-size: medium;
    transition: background-color .4s ,color .3s;
}
    ${({ type }) => type === ButtonTypes.filled && css`
    >button{
        border-radius: ${({ b_r }) => b_r || '15rem'};
       border: none;
       background-color: ${cols.main_purple};
       color: ${cols.mainLight_4};
       :hover{
           color: ${cols.main_purple};
           background-color: ${cols.mainLight_1};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.outline && css`
    >button{
        border-radius: ${({ b_r }) => b_r || '15rem'};

       border: 1px solid ${cols.main_purple};
       color: ${cols.main_blue};
       background-color: transparent;

       :hover{
           color: ${cols.mainLight_1};
           background-color: ${cols.main_blue};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.shadowed && css`
    >button{
       border-radius: ${({ b_r }) => b_r || '15px'};
       border: 1px solid ${cols.main_purple};
       color: ${cols.main_blue};
       background-color: transparent;
        box-shadow: 0 0 1rem rgba(0,0,0,0.2);
       :hover{
           color: ${cols.mainLight_1};
           background-color: ${cols.main_blue};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.disabled && css`
    >button{
       border-radius: ${({ b_r }) => b_r || '15px'};
       border: 1px solid ${cols.main_purple};
       color: ${cols.gray};
       background-color: transparent;
        box-shadow: 0 0 1rem rgba(0,0,0,0.2);
       :hover{
           color: ${cols.mainDark_1};
           background-color: ${cols.gray};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.danger && css`
    >button{
       border-radius: ${({ b_r }) => b_r || '15px'};
       border: 1px solid ${cols.red};
       color: ${cols.mainLight_1};
       background-color: ${cols.red};
        box-shadow: 0 0 1rem rgba(0,0,0,0.2);
       :hover{
           color: ${cols.red};
           background-color: ${cols.mainLight_1};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.success && css`
    >button{
       border-radius: ${({ b_r }) => b_r || '15px'};
       border: 1px solid ${cols.green};
       color: ${cols.mainLight_1};
       background-color: ${cols.green};
        box-shadow: 0 0 1rem rgba(0,0,0,0.2);
       :hover{
           color: ${cols.green};
           background-color: ${cols.mainLight_1};
        }
    }
    `};
    ${({ type }) => type === ButtonTypes.dangerOutline && css`
    >button{
       border-radius: ${({ b_r }) => b_r || '15px'};
       border: 1px solid ${cols.red};
       color: ${cols.red};
       background-color: ${cols.mainLight_1};
        box-shadow: 0 0 1rem rgba(0,0,0,0.1);
       :hover{
           color: ${cols.mainLight_1};
           background-color: ${cols.red};
        }
    }
    `};


`;
//#endregion

//#endregion

//#region Carts ss

                    // <MoContainer bg={cols.mainLight_2} align="center" eff_shdw={{op:.3,sprd:"1rem",dur:.3} } b_r={{all:".5rem"}} flex flex_dir_c min_h="25rem" pd={{t:'1rem'}} w="15rem">
                    //     <MoContainer eff_size={{val:1.2,dur:.3}} b_r={{all:".5rem"}} bg="white"   h="13rem" w="13rem"  bg_i='https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500' />
                    //     <MoContainer  w="100%" flex m_t="10px" flex_dir_c>
                    //         <MoSpan pd={{l:"20px"}} col={cols.mainDark_2} fs_mid f_w="600"> Name </MoSpan>
                    //         <MoSpan  pd={{l:"20px"}} col={cols.mainDark_2} fs_sml f_w="500"> Announcement Title  </MoSpan>
                    //     </MoContainer>
                    //     <MoContainer  w="90%" flex flex_dir_c m_t="10px" justify='space-around' pd={{b:"1rem"}}>
                    //         <MoSpan col={cols.mainLight_4} b_r={{all:"2rem"}} f_size="1.2rem" f_w="600" pd={{tb:".5rem" ,lr:"2rem"}} bg={cols.green} > 
                    //         location </MoSpan>
                    //         <MoSpan col={cols.mainLight_4} b_r={{all:"2rem"}} f_size="1.2rem" f_w="600" pd={{tb:".5rem" ,lr:"2rem"}} bg={cols.main_purple} > 
                    //         Price </MoSpan>
                    //     </MoContainer>
                    // </MoContainer>

//#endregion